import { createTheme } from "@mui/material/styles";

// MUI theme used as the default color theme only.
// Font family can be controlled globally via CSS (e.g. in index.css).
const theme = createTheme({
  // palette: {
  //   primary: {
  //     main: "#10696e",
  //   },
  // },
});

export default theme;
